module.exports = __webpack_public_path__ + "img/prize3.58be612.png";